export const ClientKey = "client" as const;
export const ClientMeKey = "me" as const;